import {NgModule} from '@angular/core';
import {TimeAgoPipe} from '@caroo/shared/time-ago/time-ago.pipe';

@NgModule({
	declarations: [TimeAgoPipe],
	exports: [TimeAgoPipe]
})
export class TimeAgoModule {
}
